import { oneOf, string } from 'prop-types'
import { kuiperClassNames, Bar } from '@opallabs/kuiper'
import './styles.scss'

const renderLogo = (logo) => <img alt="Unknown" src={`${logo}`} />

const PresentationsHeader = ({
  logo,
  logoAlignment = 'left',
  headerBackgroundColor,
  editControlsText,
}) => (
  <Bar
    align="fill"
    className={kuiperClassNames('presentations-header', `${logoAlignment}`)}
    styles={{ backgroundColor: headerBackgroundColor }}
    height="xlarge"
  >
    <span className={kuiperClassNames('logo')}>{renderLogo(logo)}</span>
    <div className={kuiperClassNames('edit-controls', `${editControlsText}`)}>
      Edit controls go here.
    </div>
  </Bar>
)

PresentationsHeader.propTypes = {
  editControlsText: string,
  headerBackgroundColor: string,
  logo: string,
  logoAlignment: oneOf(['left', 'right', 'center']),
}

export default PresentationsHeader
